<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <div style="margin-left: 30px; margin-right: 30px;">
    <div class="table-responsive">
      <table class="table table-hover table-bordered table-condensed custom-table">

        <tbody>
          <tr>
            <td colspan="12">
              <table width="100%" class="spaceboy">
                <tr>
                  <td class="bold_centered" nowrap>Description of Property</td>
                  <td class="bold_centered" style="text-align: center;" nowrap>Date Acquired<br/>(MM/DD/YYYY)</td>
                  <td class="bold_centered" style="text-align: center;" nowrap>Date Sold<br/>(MM/DD/YYYY)</td>
                  <td class="bold_centered" nowrap>Sales Price</td>
                  <td class="bold_centered" nowrap>Cost or Other Basis</td>
                  <td class="bold_centered" nowrap>Gain or (Loss)</td>
                  <td class="bold_centered">Transaction<br/>Type</td>
                  <td class="bold_centered">Loss<br/>Transaction?</td>
                  <td class="bold_centered">Worthless<br/>Stock?</td>
                  <td class="bold_centered">Section<br/>754?</td>
                </tr>
                <tr>
                  <td>
                    <input type="text" class="form-control input-sm" [(ngModel)]="scheddEditFormFields.DESCRIPTION"
                           placeholder="Enter Property Details">
                    @if (formSubmitted && !scheddEditFormFields.DESCRIPTION) {
<span class="form-error-container">Property Description is required.</span>
}
                  </td>
                  <td>
                    <input type="text" class="form-control input-sm" [(ngModel)]="scheddEditFormFields.DATE_ACQ"
                           placeholder="(MM/DD/YYYY)">
                    @if (formSubmitted && !scheddEditFormFields.DATE_ACQ) {
<span class="form-error-container">Date Acquired is required.</span>
}
                  </td>
                  <td>
                    <input type="text" class="form-control input-sm" [(ngModel)]="scheddEditFormFields.DATE_SOLD"
                           placeholder="(MM/DD/YYYY)">
                    @if (formSubmitted && !scheddEditFormFields.DATE_SOLD) {
<span class="form-error-container">Date Sold is required.</span>
}
                  </td>
                  <td>
                    <input type="text" class="form-control input-sm" [(ngModel)]="scheddEditFormFields.SALE_PRICE"
                           placeholder="Sale Price">
                    @if (formSubmitted && !scheddEditFormFields.SALE_PRICE) {
<span class="form-error-container">Sale Price is required.</span>
}
                  </td>
                  <td>
                    <input type="text" class="form-control input-sm" [(ngModel)]="scheddEditFormFields.COST_BASIS"
                           placeholder="Cost or Other Basis">
                    @if (formSubmitted && !scheddEditFormFields.COST_BASIS) {
<span class="form-error-container">Cost or Other Basis is required.</span>
}
                  </td>
                  <td>
                    <input type="text" class="form-control input-sm" [(ngModel)]="scheddEditFormFields.GAIN_LOSS"
                           placeholder="Gain or (Loss)">
                    @if (formSubmitted && !scheddEditFormFields.GAIN_LOSS) {
<span class="form-error-container">Gain or (Loss) is required.</span>
}
                  </td>
                  <td>
                    <select class="form-control" [(ngModel)]="scheddEditFormFields.TRANS_TYPE" style="font-size: 12px;">
                      <option value="">Select Transaction Type</option>
                      <option value="Temporary">Temporary</option>
                      <option value="Permanent">Permanent</option>
                    </select>
                    @if (formSubmitted && !scheddEditFormFields.TRANS_TYPE) {
<span class="form-error-container">Transaction Type is required.</span>
}
                  </td>
                  <td><input type="checkbox" [(ngModel)]="scheddEditFormFields.TRANS_TYPE_CHK_IND"></td>
                  <td><input type="checkbox" [(ngModel)]="scheddEditFormFields.WORTHLESS_FLAG_IND"></td>
                  <td><input type="checkbox" [(ngModel)]="scheddEditFormFields.IS_SEC_754_IND"></td>
                </tr>
                <tr>
                  <td>
                    <select class="form-control" [(ngModel)]="scheddEditFormFields.LINE_NO" style="font-size: 12px;">
                      <option value="">Select CGL Term</option>
                      <option value="1">Part I - Short Term</option>
                      <option value="6">Part II - Long Term</option>
                    </select>
                    @if (formSubmitted && !scheddEditFormFields.LINE_NO) {
<span class="form-error-container">CGL Term is required.</span>
}
                  </td>
                  <td style="text-align: right; font-weight: bold;">Comments</td>
                  <td colspan="4" style="font-weight: bold;">
                    <input type="text" class="form-control input-sm" [(ngModel)]="scheddEditFormFields.COMMENTS"
                           placeholder="Enter Adjustments Notes">
                  </td>
                  <td colspan="4">
                    <div style="border-top: none; text-align: center;">
                      <button class="save-button" type="button" (click)="saveScheddEdit()">
                        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save Adjustment
                      </button>
                      <button class="reset-button" type="button" (click)="resetScheddEdit()">Reset</button>
                      <button class="cancel-button" type="button" (click)="cancelScheddEdit()">Cancel</button>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <th></th>
            <th nowrap>Description of Property</th>
            <th style="text-align: center;" nowrap>Date Acquired</th>
            <th style="text-align: center;" nowrap>Date Sold</th>
            <th nowrap>Sales Price</th>
            <th nowrap>Cost or Other Basis</th>
            <th nowrap>Gain or (Loss)</th>
            <th>Transaction Type</th>
            <th>Loss Transaction?</th>
            <th>Worthless Stock?</th>
            <th>Section 754?</th>
            <th></th>
          </tr>
        </tbody>

        <tbody>
          <tr style="background-color: #EEE;">
            <td style="font-weight: bold;">1</td>
            <td colspan="11" style="font-weight: bold;">Part I Short-Term Capital Gains and Losses - Assets Held One Year or Less</td>
          </tr>
          @if (noLineOneGLRecords) {
<tr>
            <td>&nbsp;</td>
            <td align="center" colspan="11">No Existing Short-Term Capital Gains and Losses</td>
          </tr>
}
          @for (lineOneGL of lineOneGLs; track $index) {
<tr>
            <td (click)="loadRowEdit(lineOneGL)"><i class="fa fa-pencil bluepencil"></i></td>
            <td>{{lineOneGL.DESCRIPTION}}</td>
            <td style="text-align: right;">{{lineOneGL.DATE_ACQ}}</td>
            <td style="text-align: right;">{{lineOneGL.DATE_SOLD}}</td>
            <td style="text-align: right;" [ngClass]="{'color-red': lineOneGL.SALE_PRICE < 0}">{{formatNumber(lineOneGL.SALE_PRICE)}}</td>
            <td style="text-align: right;" [ngClass]="{'color-red': lineOneGL.COST_BASIS < 0}">{{formatNumber(lineOneGL.COST_BASIS)}}</td>
            <td style="text-align: right;" [ngClass]="{'color-red': lineOneGL.GAIN_LOSS < 0}">{{formatNumber(lineOneGL.GAIN_LOSS)}}</td>
            <td>{{lineOneGL.TRANS_TYPE}}</td>
            <td>{{lineOneGL.TRANS_TYPE_CHK}}</td>
            <td>{{lineOneGL.WORTHLESS_FLAG}}</td>
            <td>{{lineOneGL.IS_SEC_754}}</td>
            <td (click)="adjustmentDelete(lineOneGL)"><i class="fa fa-minus-circle color-red redminus"></i></td>
          </tr>
}
          <tr>
            <td style="font-weight: bold; background-color: #EEE;">4</td>
            <td colspan="5" style="font-weight: bold; background-color: #EEE;">Unused capital loss carryover (attach computation)</td>
            <td style="text-align: right;" [ngClass]="{'color-red': rowData.AGGR_TB < 0}">{{formatNumber(lineFourUnusedCapLossCarryover)}}</td>
            <td colspan="5" style="background-color: #EEE;">&nbsp;</td>
          </tr>
          <tr style="background-color: #EEE;">
            <td style="font-weight: bold;">6</td>
            <td colspan="11" style="font-weight: bold;">Part II Long-Term Capital Gains and Losses - Assets Held More Than One Year</td>
          </tr>
          @if (noLineSixGLRecords) {
<tr>
            <td>&nbsp;</td>
            <td align="center" colspan="11">No Existing Long-Term Capital Gains and Losses</td>
          </tr>
}
          @for (lineSixGL of lineSixGLs; track $index) {
<tr>
            <td (click)="loadRowEdit(lineSixGL)"><i class="fa fa-pencil bluepencil"></i></td>
            <td>{{lineSixGL.DESCRIPTION}}</td>
            <td style="text-align: right;">{{lineSixGL.DATE_ACQ}}</td>
            <td style="text-align: right;">{{lineSixGL.DATE_SOLD}}</td>
            <td style="text-align: right;" [ngClass]="{'color-red': lineSixGL.SALE_PRICE < 0}">{{formatNumber(lineSixGL.SALE_PRICE)}}</td>
            <td style="text-align: right;" [ngClass]="{'color-red': lineSixGL.COST_BASIS < 0}">{{formatNumber(lineSixGL.COST_BASIS)}}</td>
            <td style="text-align: right;" [ngClass]="{'color-red': lineSixGL.GAIN_LOSS < 0}">{{formatNumber(lineSixGL.GAIN_LOSS)}}</td>
            <td>{{lineSixGL.TRANS_TYPE}}</td>
            <td>{{lineSixGL.TRANS_TYPE_CHK}}</td>
            <td>{{lineSixGL.WORTHLESS_FLAG}}</td>
            <td>{{lineSixGL.IS_SEC_754}}</td>
            <td (click)="adjustmentDelete(lineSixGL)"><i class="fa fa-minus-circle color-red redminus"></i></td>
          </tr>
}
          <tr style="background-color: #EEE;">
            <td colspan="6" style="font-weight: bold;">Total Schedule D Gain or (Loss)</td>
            <td style="text-align: right; font-weight: bold;" [ngClass]="{'color-red': rowData.AGGR_CGNI < 0}">{{formatNumber(rowData.AGGR_CGNI)}}</td>
            <td colspan="5"></td>
          </tr>
          <tr style="background-color: #EEE;">
            <td colspan="6" style="font-weight: bold;">Total Gain (Loss) per Tax Return</td>
            <td style="text-align: right; font-weight: bold;" [ngClass]="{'color-red': rowData.AGGR_TB < 0}">{{formatNumber(rowData.AGGR_TB)}}</td>
            <td colspan="5"></td>
          </tr>
          <tr style="background-color: #EEE;">
            <td colspan="6" style="font-weight: bold;">Unallocated Amount</td>
            <td style="text-align: right; font-weight: bold;" [ngClass]="{'color-red': rowData.AGGR_DIFF < 0}">{{formatNumber(rowData.AGGR_DIFF)}}</td>
            <td colspan="5"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-footer">
      <button class="cancel-button" type="button" (click)="closeModal()">Close</button>
    </div>
  </div>
</div>
